import { Box, makeStyles, Typography } from "@material-ui/core";
import { useRedirect } from "react-admin";
import { AppResource } from "../../types/resource.types";

const useStyles = makeStyles((theme) => ({
  reviewCard: {
    backgroundColor: "#fff",
    padding: "16px 20px",
    width: "225px",
    marginRight: "12px",
    marginBottom: "16px",
    borderRadius: 12,
    boxShadow: `0px 2px 5px ${theme.palette.grey[400]}`,
    "& p": {
      cursor: "pointer",
    },
  },
}));

const AdminReviews = () => {
  const classes = useStyles();
  const redirect = useRedirect();

  const handleRedirect = (vendor: string) => {
    redirect(`/${vendor}`);
  };

  return (
    <Box
      style={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <Box className={classes.reviewCard}>
        <Typography onClick={() => handleRedirect(AppResource.sportsClubsReviews)}>Playground Reviews</Typography>
      </Box>
      <Box className={classes.reviewCard}>
        <Typography onClick={() => handleRedirect(AppResource.gymReviews)}>Gym Reviews</Typography>
      </Box>
      <Box className={classes.reviewCard}>
        <Typography onClick={() => handleRedirect(AppResource.academyReviews)}>Academies Reviews</Typography>
      </Box>
      <Box className={classes.reviewCard}>
        <Typography onClick={() => handleRedirect(AppResource.coachReviews)}>Sessions Reviews</Typography>
      </Box>
      <Box className={classes.reviewCard}>
        <Typography onClick={() => handleRedirect(AppResource.entertainmentReviews)}>Entertainment Reviews</Typography>
      </Box>
    </Box>
  );
};

export default AdminReviews;
